/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Playdata_Common_Backtonews2Inputs */

const ja_playdata_common_backtonews2 = /** @type {(inputs: Playdata_Common_Backtonews2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ニュース一覧へ戻る`)
};

const en_playdata_common_backtonews2 = /** @type {(inputs: Playdata_Common_Backtonews2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Back to news`)
};

/**
* | output |
* | --- |
* | "Back to news" |
*
* @param {Playdata_Common_Backtonews2Inputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
const playdata_common_backtonews2 = /** @type {((inputs?: Playdata_Common_Backtonews2Inputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Playdata_Common_Backtonews2Inputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_playdata_common_backtonews2(inputs)
	return en_playdata_common_backtonews2(inputs)
});
export { playdata_common_backtonews2 as "playdata_common_backToNews" }